// ** Initial State
const initialState = {
  allData: [],
  data: null,
  pricing: [],
  syncdata: [],
  exhibitor: [],
  notes: null,
  bookingData: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  registrationDataWithPagintion: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  modifiedInitiatedRegistration: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  registrationLog:null,
  pageLoader:true,
  changedRegisterType:null,
  sendPaymentLink:null,
  registrationLogData:null,
  cancelRegistrationTypeChange:null,
  updateRefund:null,
  emailTemplate:null,
  resendEmail:null,
  user_password: null,
  cancel_user:null,
  refund_cron_job:null
}

const registrationRecords = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_REG':
      return { ...state, allData: action.data }
    case 'GET_REG':
      return { ...state, data: action.data }
    case 'SET_REG':
      return { ...state, data: action.data }
    case 'NOTES':
      return { ...state, notes: action.data }  
    case 'GET_ALL_PRICING':
      return { ...state, pricing: action.data }
    case 'DEL_REG':
      return { ...state, data: action.data }  
    case 'SYNC_USER_DATA':
        return { ...state, syncdata: action.data }
    case 'GET_EXHIBITOR':
      return { ...state, exhibitor: action.data }
    case 'GET_BOOKING_WITH_PAGINATION':
      return { ...state, bookingData: action.data, pageLoader: false }
    case 'GET_ALL_REGISTRATION_WITH_PAGINATION':
      return { ...state, registrationDataWithPagintion: action.data, pageLoader: false }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    case 'GET_REG_LOG':
        return { ...state, registrationLog: action.data}
    case 'CHANGE_REG_TYPE':
      return { ...state, changedRegisterType: action.data}
    case 'GET_ALL_REGISTRATION_MODFICATION_INITIATED':
      return { ...state, modifiedInitiatedRegistration: action.data, pageLoader: false }
    case 'SEND_PAYMENT_LINK':
      return { ...state, sendPaymentLink: action.data }
    case 'GET_REGISTRATION_LOG_DATA':
      return { ...state, registrationLogData: action.data }
    case 'CANCEL_REGISTRATION_TYPE_CHANGE':
      return { ...state, cancelRegistrationTypeChange: action.data }
    case 'UPDATE_REFUND_STATUS':
      return { ...state, updateRefund: action.data }
    case 'UPDATE_EMAIL_TEMPLATE':
      return { ...state, emailTemplate: action.data }
    case 'RESEND_EMAIL':
      return { ...state, resendEmail: action.data }
    case 'UPDATE_USER_PASSWORD':
      return { ...state, user_password: action.data }
 case 'CANCEL_USER':
      return { ...state, cancel_user: action.data }
 case 'REFUND_CRON_JOB_REFRESH':
      return { ...state, refund_cron_job: action.data }

    default:
      return { ...state }
  }
}
export default registrationRecords
